import type { ReactNode } from "react";

interface PreviewFieldProps {
  label: string;
  children: ReactNode;
}

export const PreviewField = ({ label, children }: PreviewFieldProps) => (
  <div className="mb-6">
    <div className="mb-2 bg-gradient-to-r from-purple-600 to-purple-400 bg-clip-text text-sm font-medium text-transparent">
      {label}
    </div>
    {children}
  </div>
);
